import { computed } from 'mobx';

import { preloaders } from '../utils';

import { isOfflineStore, paymentTrackerStore, currentPaymentStore } from '../stores';

import { changeDistanceConditions } from './changeDistanceConditions';
import { mainConditions } from './mainConditions';
import { distanceSelector } from './mappedData';

const isContinueEnabled = computed(() => {
  const distanceId = distanceSelector.id.get();

  const isPendingPayment = paymentTrackerStore.isPending(distanceId);
  const isPaymentInProgress = currentPaymentStore.isPaymentInProgress;

  if (preloaders.submitInProgress.isLoading()) {
    return false;
  }

  return [
    !mainConditions.isAlreadyRegisteredAndNotInvited.get(),
    !mainConditions.isRegistrationOutdated.get(),
    !mainConditions.isRegistrationClosed.get(),
    !mainConditions.isDistanceSoldOut.get(),
    !mainConditions.isInvalidInviteToken.get(),
    !changeDistanceConditions.isEmailMismatch.get(),
    !isOfflineStore.value,
    !isPaymentInProgress,
    !isPendingPayment,
  ].every(Boolean);
});

export { isContinueEnabled };
